import React from "react";
import Title from "../components/header/Title";
import ComingSoon from "../components/common/ComingSoon";

const CreateRole: React.FC = () => {
  return (
    <React.Fragment>
      <Title title="Add Role" subtitle="Create a New Role" />
      <ComingSoon label="Role creation" />
    </React.Fragment>
  );
};

export default CreateRole;
